import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Self-hosted interface fonts — no network fetch at runtime (local-first).
import "@fontsource/geist-sans/400.css";
import "@fontsource/geist-sans/500.css";
import "@fontsource/geist-sans/600.css";
import "@fontsource/geist-mono/400.css";
import "@fontsource/geist-mono/500.css";

import "@/styles/globals.css";

import { App } from "@/App";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { logger } from "@/services/logger";
import { clearChunkErrorFlag } from "@/utils";

// Reaching this line means the current bundle booted fine, so any earlier
// stale-chunk reload guard no longer applies.
clearChunkErrorFlag();

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element #root not found");
}

// Surface anything that escapes React's tree.
window.addEventListener("error", (e) => {
  logger.error("window", `Unhandled error: ${e.message}`);
});
window.addEventListener("unhandledrejection", (e) => {
  logger.error("window", "Unhandled promise rejection", e.reason);
});

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
